/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/* eslint-disable import/no-extraneous-dependencies */
import merge from 'deepmerge';
import { grey } from '@mui/material/colors';
/**
 * Theme related implementation added here
 */
const customBlue = {
  50: '#e9f0fb',
  100: '#c8daf4',
  200: '#a3c1ed',
  300: '#7ea8e5',
  400: '#6395e0',
  500: '#4782da',
  600: '#407ad6',
  700: '#3F8CFC',
  800: '#2f65cb',
  900: '#2052c2 ',
};
//
const customDark = {
  50: '#2e384a',
};
//
const defaultVariant = {
  name: 'blue',
  appName: 'Preferred',
  appLogo: '/static/assets/preferred.png',
  palette: {
    mode: 'light',
    primary: {
      main: customBlue[700],
      contrastText: '#FFF',
    },
    secondary: {
      main: customBlue[500],
      contrastText: '#FFF',
    },
    danger: {
      main: '#d50000',
    },
    background: {
      default: '#f7f7f7',
      paper: '#FFF',
    },
  },
  header: {
    color: grey[500],
    background: customDark[50],
    search: {
      color: grey[800],
    },
    indicator: {
      background: customBlue[600],
    },
  },
  footer: {
    color: grey[500],
    background: '#FFF',
  },
};

const customGreen = '#1C5A68';
const customYellow = '#ebd18b';

const brownVariant = merge(defaultVariant, {
  name: 'brown',
  appName: 'Historic',
  appLogo: '/static/assets/historic.svg',
  palette: {
    mode: 'light',
    primary: {
      main: customGreen,
      contrastText: '#FFF',
    },
    secondary: {
      main: customYellow,
      contrastText: '#FFF',
    },
    background: {
      default: '#f7f7f7',
      paper: '#FFF',
    },
  },
  header: {
    color: customYellow,
    background: customGreen,
    search: {
      color: customYellow,
    },
    indicator: {
      background: customYellow,
    },
  },
  footer: {
    color: grey[500],
    background: '#FFF',
  },
});

const customBeyondGreen = '#2f4031';
const customOrange = '#b67234';
const customBeyondGreenButton = '#1a4356';

const greenVariant = merge(defaultVariant, {
  name: 'green',
  appName: 'Beyond Green',
  appLogo: '/static/assets/beyond-green.png',
  palette: {
    mode: 'light',
    primary: {
      main: customBeyondGreenButton,
      contrastText: '#FFF',
    },
    secondary: {
      main: customBeyondGreenButton,
      contrastText: '#FFF',
    },
    background: {
      default: '#f7f7f7',
      paper: '#FFF',
    },
  },
  header: {
    color: customOrange,
    background: customBeyondGreen,
    search: {
      color: customOrange,
    },
    indicator: {
      background: customOrange,
    },
  },
  footer: {
    color: grey[500],
    background: '#FFF',
  },
});
//
const airoBlue = '#272E52';
const airoLightBlue = '#009BCD';

const lightBlueVariant = merge(defaultVariant, {
  name: 'light-blue',
  appName: 'aiRO',
  appLogo: '/static/assets/airo.png',
  palette: {
    mode: 'light',
    primary: {
      main: airoBlue,
      contrastText: '#FFF',
    },
    secondary: {
      main: airoLightBlue,
      contrastText: '#FFF',
    },
    background: {
      default: '#f7f7f7',
      paper: '#FFF',
    },
  },
  header: {
    color: airoLightBlue,
    background: airoBlue,
    search: {
      color: airoLightBlue,
    },
    indicator: {
      background: airoLightBlue,
    },
  },
  footer: {
    color: grey[500],
    background: '#FFF',
  },
});
//
const variants = [defaultVariant, greenVariant, brownVariant, lightBlueVariant];
//
export default variants;
